import { normalizeEffectPlaybackAudience, type PartyCueTriggered, type RoomEffect } from "../../models/contracts";

const SYNCHRONIZED_EFFECT_LEAD_MS = 5_000;
const EFFECT_EXPIRY_GRACE_MS = 30_000;

interface EffectCueConfiguration {
  effectId?: unknown;
  durationMs?: unknown;
  animationKey?: unknown;
  isSynchronized?: unknown;
}

export function effectFromCue(cue: PartyCueTriggered): RoomEffect | null {
  if (cue.action !== "trigger_effect") return null;

  try {
    const configuration = JSON.parse(
      cue.actionConfigurationJson ?? "{}",
    ) as EffectCueConfiguration;
    if (
      typeof configuration.effectId !== "string" ||
      !configuration.effectId.trim()
    ) {
      return null;
    }

    const configuredDuration =
      typeof configuration.durationMs === "number"
        ? configuration.durationMs
        : null;
    const durationMs =
      configuredDuration && configuredDuration > 0
        ? configuredDuration
        : (cue.durationSeconds ?? 0) * 1_000;
    const serverTimeMs = Date.parse(cue.serverTime);
    if (!Number.isFinite(serverTimeMs) || durationMs <= 0) return null;

    const synchronized = configuration.isSynchronized === true;
    const scheduledStartMs =
      serverTimeMs + (synchronized ? SYNCHRONIZED_EFFECT_LEAD_MS : 0);
    const animationKey =
      typeof configuration.animationKey === "string" &&
      configuration.animationKey.trim()
        ? configuration.animationKey
        : configuration.effectId;

    return {
      roomId: cue.roomId,
      effectId: configuration.effectId,
      effectType: "Movie",
      effectMode: "animation",
      durationMs,
      color: null,
      animationKey,
      scheduledStartUtc: new Date(scheduledStartMs).toISOString(),
      serverTime: cue.serverTime,
      eventId: `cue:${cue.cueId}:${cue.serverTime}`,
      expiresAtUtc: new Date(
        scheduledStartMs + durationMs + EFFECT_EXPIRY_GRACE_MS,
      ).toISOString(),
      playbackAudience: normalizeEffectPlaybackAudience(cue.playbackAudience),
    };
  } catch {
    return null;
  }
}
